<app-tagline></app-tagline>
<app-navbar [navClass] = "'defaultscroll is-sticky tagline-height'" [navLight]="true"></app-navbar>


<section class="swiper-slider-hero relative block h-[85vh] overflow-x-hidden" id="home">
    <div class="swiper-container absolute end-0 top-0 w-full h-full">
        <div class="swiper-wrapper">
            <div class="swiper-slide flex items-center overflow-hidden">
                <div class="slide-inner absolute end-0 top-0 w-full h-full slide-bg-image flex items-center bg-[url('/assets/images/bg/4.jpg')] bg-center;">
                    <div class="absolute inset-0 bg-black/40"></div>
                    <div class="container relative">
                        <div class="grid grid-cols-1">
                            <div class="text-center">
                                <h1 class="font-bold text-white lg:leading-normal leading-normal text-4xl lg:text-6xl mb-6 mt-5">Let the journey begin...</h1>
                                <p class="text-white/70 text-xl max-w-xl mx-auto">Planning for a trip? We will organize your trip with the best places and within best budget!</p>
                                
                                <div class="mt-12">
                                    <app-form></app-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <div class="swiper-slide flex items-center overflow-hidden">
                <div class="slide-inner absolute end-0 top-0 w-full h-full slide-bg-image flex items-center bg-center bg-[url('/assets/images/bg/5.jpg')]">
                    <div class="absolute inset-0 bg-black/40"></div>
                    <div class="container relative">
                        <div class="grid grid-cols-1">
                            <div class="text-center">
                                <h1 class="font-bold text-white lg:leading-normal leading-normal text-4xl lg:text-6xl mb-6 mt-5">Let the journey begin...</h1>
                                <p class="text-white/70 text-xl max-w-xl mx-auto">Planning for a trip? We will organize your trip with the best places and within best budget!</p>
                                
                                <div class="mt-12">
                                    <app-form></app-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="swiper-slide flex items-center overflow-hidden">
                <div class="slide-inner absolute end-0 top-0 w-full h-full slide-bg-image flex items-center bg-center bg-[url('/assets/images/bg/6.jpg')]">
                    <div class="absolute inset-0 bg-black/40"></div>
                    <div class="container relative">
                        <div class="grid grid-cols-1">
                            <div class="text-center">
                                <h1 class="font-bold text-white lg:leading-normal leading-normal text-4xl lg:text-6xl mb-6 mt-5">Let the journey begin...</h1>
                                <p class="text-white/70 text-xl max-w-xl mx-auto">Planning for a trip? We will organize your trip with the best places and within best budget!</p>
                                
                                <div class="mt-12">
                                    <app-form></app-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>

        <div class="swiper-pagination"></div>
    </div>
</section>

<section class="relative md:py-24 py-16 overflow-hidden">
    <div class="container relative">
        <div class="grid grid-cols-1 pb-8 text-center">
            <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Top Destinations</h3>
            <p class="text-slate-400 max-w-xl mx-auto">Planning for a trip? We will organize your trip with the best places and within best budget!</p>
        </div>

        <div class="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 relative mt-6 gap-6">
            <div *ngFor="let item of topDestination" class="group relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                <img [src]="item.image" class="scale-125 group-hover:scale-100 duration-500" alt="">
                <div class="absolute inset-0 bg-gradient-to-b to-slate-900 from-transparent opacity-0 group-hover:opacity-100 duration-500"></div>
                <div class="absolute p-4 bottom-0 start-0">
                    <a [routerLink]="[]" class="text-lg font-medium text-white hover:text-red-500 duration-500 ease-in-out">{{item.place}}</a>
                    <p class="text-white/70 group-hover:text-white text-sm duration-500">{{item.hotel}}</p>
                </div>
            </div>
        </div>
    </div>

    <app-about></app-about>

    <div class="container relative md:mt-24 mt-16">
        <div class="grid grid-cols-1 pb-8 text-center">
            <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Tours Packages</h3>

            <p class="text-slate-400 max-w-xl mx-auto">Planning for a trip? We will organize your trip with the best places and within best budget!</p>
        </div>

        <div class="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
            <div *ngFor="let item of package" class="group rounded-md shadow dark:shadow-gray-700">
                <app-grid-data [packageData]="item"></app-grid-data>
            </div>
        </div>
    </div>

    <app-client></app-client>
</section>
<app-image-slider></app-image-slider>
<app-footer></app-footer>
<app-switcher></app-switcher>